import { TDeviceType } from '@cian/ui-kit';
import { ca } from '@cian/analytics';
import { PAGE_TYPE } from '../../constants/pageType';
import { getSiteType } from '../../utils/getSiteType';

export const trackGoToRealtor = (deviceType: TDeviceType) => {
  ca('eventSite', {
    name: 'oldevent',
    category: 'Application_to_realtor',
    action: 'Click',
    label: 'Banner',
    page: {
      pageType: PAGE_TYPE,
      siteType: getSiteType(deviceType),
      extra: {
        banner_location: 'specialists_page_empty',
      },
    },
  });
};

export const trackShowEmpty = () => {
  ca('eventSite', {
    name: 'oldevent',
    category: 'Application_to_realtor',
    action: 'Show',
    label: 'Banner',
  });
};
